import React, { useState } from "react";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import TypeIcon, { iconLabel } from "../../app/typeIcons";
import { brand } from "../../../theme/businessFlowsTheme";

// An icon from the fixed set the explorer, cards and legends can draw.
export default function IconPicker({ value, icons = [], colour, onChange, disabled = false, label = "Icon" }) {
  const [anchor, setAnchor] = useState(null);

  const choose = (icon) => {
    setAnchor(null);
    if (icon !== value) onChange(icon);
  };

  return (
    <>
      <Tooltip title={label}>
        <span>
          <ButtonBase
            disabled={disabled}
            aria-label={`${label}: ${iconLabel(value)}`}
            onClick={(e) => {
              e.stopPropagation();
              setAnchor(e.currentTarget);
            }}
            sx={{ width: 32, height: 32, borderRadius: 2, display: "grid", placeItems: "center", bgcolor: brand.canvas, color: colour || brand.ink, border: `1px solid ${brand.line}`, flexShrink: 0 }}
          >
            <TypeIcon name={value} fontSize="small" />
          </ButtonBase>
        </span>
      </Tooltip>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ className: "bfx", sx: { p: 1.5, borderRadius: 3, width: 264 } }}
      >
        <Typography variant="caption" sx={{ fontWeight: 700 }}>
          {label}
        </Typography>
        <Box sx={{ mt: 1, display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 0.75 }}>
          {icons.map((icon) => {
            const active = icon === value;
            return (
              <Tooltip key={icon} title={iconLabel(icon)}>
                <ButtonBase
                  aria-label={iconLabel(icon)}
                  aria-pressed={active}
                  onClick={() => choose(icon)}
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: 2,
                    display: "grid",
                    placeItems: "center",
                    color: active ? "#fff" : brand.ink,
                    bgcolor: active ? colour || brand.ink : "transparent",
                    "&:hover": { bgcolor: active ? colour || brand.ink : brand.canvas },
                    "&:focus-visible": { outline: `2px solid ${brand.ink}` },
                  }}
                >
                  <TypeIcon name={icon} fontSize="small" />
                </ButtonBase>
              </Tooltip>
            );
          })}
        </Box>
      </Popover>
    </>
  );
}
